class NaptonCanalTransition extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.loadObserver?.disconnect();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.button = this.querySelector('[data-transition-pause]');
    this.paused = false;
    this.inView = false;
    this.button.addEventListener('click', () => {
      this.paused = !this.paused;
      this.syncMotion();
    }, { signal });
    this.reduced.addEventListener('change', () => this.syncMotion(), { signal });
    document.addEventListener('visibilitychange', () => this.syncMotion(), { signal });
    if ('IntersectionObserver' in window) {
      this.loadObserver = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) this.loadArtwork();
      }, { rootMargin: '200px 0px' });
      this.loadObserver.observe(this);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.syncMotion();
      }, { threshold: .1 });
      this.observer.observe(this);
    } else {
      this.loadArtwork();
    }
    this.syncMotion();
  }
  loadArtwork() {
    const template = this.querySelector('[data-transition-art]');
    if (template) {
      this.prepend(template.content.cloneNode(true));
      template.remove();
    }
    this.dataset.loaded = 'true';
    this.loadObserver?.disconnect();
    this.syncMotion();
  }
  syncMotion() {
    const loaded = this.dataset.loaded === 'true';
    this.classList.toggle('nct-playing', loaded && this.inView && !this.paused && !this.reduced.matches && !document.hidden);
    this.button.hidden = !loaded || this.reduced.matches || !('IntersectionObserver' in window);
    this.button.setAttribute('aria-pressed', String(this.paused));
    this.button.textContent = this.paused ? this.button.dataset.play : this.button.dataset.pause;
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.loadObserver?.disconnect();
  }
}
if (!customElements.get('napton-canal-transition')) customElements.define('napton-canal-transition', NaptonCanalTransition);

